import { units } from '@ui/css';
import { combineTokens, makeScaleableToken } from '@utils/css';

const tokens = combineTokens("--ribbon", {
  size: units.px(50),
  contentMargin: [units.px(25), makeScaleableToken],
  top: `min(${units.px(20)}, calc(50% - ${units.px(25)}))`
});
const ribbonTokens = tokens;
const ribbon = "oaer19zgaco";

export { ribbon, ribbonTokens };
import "./atom.ribbon.style.linaria.module.css";
//# sourceMappingURL=atom.ribbon.style.js.map
